// src/pages/CreditBreakdown.jsx
import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import { useAppContext } from '../AppProvider';
import {useEffect, useState} from 'react'

const CreditBreakdown = ({loadingReferral}) => {

    const { isSearchMoved, setIsSearchMoved, setCurrentConversation, setNewSearch, setErrorDisplay, setQueries, setIds, setIdHistory, userCredits, creditsLoading, totalUserCredits,
      dailyUserCredits, temporaryUserCreditsList, lifetimeUserCredits, temporaryExpiries, totalTemporaryUserCredits
     } = useAppContext();  

     const [refresh, setRefresh] = useState(false)

     useEffect(() => {
      setRefresh(!refresh)
    }, [loadingReferral]);
    
  return (
    <Box sx={{ p: 1 }}>
      {/* <Typography variant="h5" gutterBottom>
        Credit Breakdown
      </Typography> */}

      {/* <Typography variant="h6">Total Credits: {totalUserCredits}</Typography> */}

      <List>
        <ListItem>Total Credits: {userCredits}</ListItem>
        <ListItem>Daily Credits: {dailyUserCredits}</ListItem>
        <ListItem>Lifetime Credits: {lifetimeUserCredits}</ListItem>
        <ListItem>Total Temporary Credits: {totalTemporaryUserCredits}</ListItem>
        <ListItem>
          Temporary Credits Breakdown List:
          <ul style={{ margin: 0, paddingLeft: 16 }}>
            {temporaryUserCreditsList.map((credit, i) => (
              <li key={i}>
                {credit} (expires {new Date(temporaryExpiries[i]).toLocaleDateString()})
              </li>
            ))}
          </ul>
        </ListItem>
      </List>
    </Box>
  );
};

export default CreditBreakdown;
